export enum ChipStyleEnum {
  DEFAULT   = "mp-chip-contained",
  OUTLINE   = "mp-chip-outline",
  CONTAINED = "mp-chip-contained"
}
